import * as yup from 'yup';

import { ObjectTypeBase } from 'lane-shared/types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from 'lane-shared/types/properties/Property';
import { AllTypeContexts } from 'lane-shared/types/properties/TypeContextEnum';

import Types from '../../../../properties/Types';
import { TYPE_GROUP_INTEGRATION } from '../../../../properties/constants';
import createShapeFromProperties from '../../../../properties/createShapeFromProperties';

const properties: PropertiesInterface = {
  name: {
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
      {
        name: 'Min',
        value: 2,
      },
      {
        name: 'Max',
        value: 64,
      },
    ],
  },
  suites: {
    type: 'String',
    isArray: true,
    default: [],
  },
};

export class ServiceRequestFloorType extends ObjectTypeBase {
  group = TYPE_GROUP_INTEGRATION;

  name = 'ServiceRequestFloor';

  friendlyName = 'Service Request Floor';

  superUserOnly = true;

  contexts = AllTypeContexts;

  get example() {
    return {
      name: '05',
      suites: ['Suite 500', 'Suite 501'],
    };
  }

  get default(): any {
    return {
      name: '',
      suites: [],
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

const definition = new ServiceRequestFloorType();

Types.addType(definition);
export default definition;
